"use client";

import { YouTubeEmbed } from "@next/third-parties/google";
import ResourceEmbed from "@/components/resources/ResourceEmbed";
import VideoPlayer from "@/components/resources/VideoPlayer";
import { getInlinePlayback } from "@/lib/resources/media-kind";
import { getYouTubeId } from "@/lib/resources/videoThumbnail";

/**
 * A resource's media, played where it is shown: the playbook row it opens in
 * and the card under Sabine's answer that names it. Renders nothing for a
 * resource that is not media (see `getInlinePlayback`).
 */
export default function ResourcePlayer({ resource }) {
  const url = resource?.url;
  switch (getInlinePlayback(resource)) {
    case "embed":
      return <ResourceEmbed value={url} title={resource.label || "Embedded resource"} />;
    case "youtube":
      return (
        <div className="aspect-video w-full">
          <YouTubeEmbed videoid={getYouTubeId(url)} />
        </div>
      );
    case "video":
      return <VideoPlayer src={url} className="aspect-video w-full" />;
    case "audio":
      return (
        <audio controls preload="metadata" className="w-full" src={url}>
          Your browser does not support the audio element.
        </audio>
      );
    default:
      return null;
  }
}
